module.exports = __webpack_public_path__ + "img/btn_LOW_win.3508eb6b.png";